import { render, staticRenderFns } from "./OrbitSetupModal.vue?vue&type=template&id=0492a036"
import script from "./OrbitSetupModal.vue?vue&type=script&lang=ts"
export * from "./OrbitSetupModal.vue?vue&type=script&lang=ts"
import style0 from "./OrbitSetupModal.vue?vue&type=style&index=0&id=0492a036&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports